export default class PasswordManagementFormModel {
  currentPassword = ''

  newPassword = ''

  confirmNewPassword = ''
}
